<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <b-container fluid>
    <div class="iq-card mt-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title my-2">
          <h4 class="card-title">Device Log Detail</h4>
        </div>
        <div class="row">
          <div class="col-md-12 my-2">
            <div class="text-right">
              <button-options
                :access="canRead('master_device')"
                :hideDetail="true"
                :isBackEnabled="true"
                :isRefreshEnabled="true"
                :isRefreshed="isLoading"
                @onRefreshed="load('Refreshed')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="iq-card-body">
        <div class="row" v-if="deviceData">
          <div class="col-md-12">
            <div
              class="device-info-bar"
              style="display: flex; flex-wrap: wrap; gap: 8px 20px; padding-bottom: 10px; margin-bottom: 10px; border-bottom: 1px solid #e2e8f0;"
            >
              <span><strong>{{ deviceData.devcName }}</strong></span>
              <span class="text-muted">{{ deviceData.devcType }}</span>
              <span v-if="deviceData.devcLabel">Label: {{ deviceData.devcLabel }}</span>
              <span>Unique ID: {{ deviceData.devcUniqueId }}</span>
              <span v-if="assetName">Asset: {{ assetName }}</span>
            </div>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-md-12">
            <div class="mb-3" v-if="dateParam">
              <date-picker
                :dateParam="dateParam"
                :isInline="true"
                :isLoading="isLoading"
                :enableInterval="true"
                @onSubmitRange="onSubmitRange"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="isLoading">
          <div class="col-md-12">
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle mr-3"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
        <div class="row mt-3" v-if="related.devcType === 'gps'">
          <div class="col-md-4">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              Total Cruise
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ gpsSummary.totalCruise | toKM }} KM</span>
            </span>
          </div>
          <div class="col-md-4">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              Average Speed
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ gpsSummary.averageSpeed | toKnot }} Knot</span>
            </span>
          </div>
          <div class="col-md-4">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              Distance
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ gpsSummary.distance | toKM }} KM</span>
            </span>
          </div>
        </div>

        <!-- FlowMeter Summary -->
        <div class="row mt-3" v-if="related.devcType === 'flowmeter'">
          <div class="col-md-4">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              Flowing Time
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ flowmeterSummary.flowingTime | toDuration }}</span>
            </span>
          </div>
          <div class="col-md-4">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              Average Flow Rate
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ $fmt(flowmeterSummary.averageFlow, 2) }} L/h</span>
            </span>
          </div>
          <div class="col-md-4">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              Total Flow
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ $fmt(flowmeterSummary.totalFlow, 2) }} Liters</span>
            </span>
          </div>
        </div>
        <!-- ./Flowmeter Summary -->

        <!-- AE Summary -->
        <div class="row mt-3" v-if="related.devcType === 'ae'">
          <div class="col-md-4" v-for="(ae, index) in aesTotal" :key="index">
            <h6 class="card-title text-uppercase text-secondary mb-0">
              AE {{ index + 1 }} Running Hours
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ ae | toDuration }}</span>
            </span>
          </div>
        </div>
        <!-- ./AE Summary -->

        <!-- Limit Switch Summary -->
        <div class="row mt-3" v-if="related.devcType === 'limitswitch'">
          <div class="col-md-4">
            <h6 class="card-title
              text-uppercase text-secondary mb-0">
              Total Duration
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ limitSwitchSummary.totalDuration | toDuration }}
              </span>
            </span>
          </div>
          <div class="col-md-4">
            <h6 class="card-title
              text-uppercase text-secondary mb-0">
              Selection Duration
            </h6>
            <span class="h2 text-dark mb-0 counter d-inline-block w-100">
              <span>{{ limitSwitchSummary.selectionDuration | toDuration }}
              </span>
            </span>
          </div>
        </div>
        <!-- ./Limit Switch Summary -->
      </div>
    </div>
    <div class="iq-card">
      <div class="iq-card-body">
        <!-- <pre>{{ related.logs }}</pre> -->
        <b-table
          striped
          hover
          fixed
          small
          :busy="isLoading"
          :fields="related.fields"
          :items="related.logs"
        >
          <template v-slot:table-busy="">
            <div class="text-center text-danger my-2">
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-3"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </b-container>
</template>

<script>
import AssetSvc from '@/services/AssetSvc';
import ButtonOptions from '@/components/directives/button-options';
import DeviceSvc from '@/services/DeviceSvc';
import SeriesSvc from '@/services/SeriesSvc';

import DatePicker from '@/components/directives/date-picker';
import dateUtil from '@/util/date';

import requestBuilder from '@/util/request.builder';

import deviceLogAdapters from './adapters';
import { mapSeriesWithDatetime } from './adapters/shared';

export default {
  name: 'DeviceDetail',
  components: {
    DatePicker,
    ButtonOptions,
  },
  data() {
    return {
      gpsSummary: {
        totalCruise: 0,
        averageSpeed: 0,
        distance: 0,
      },
      flowmeterSummary: {
        averageFlow: 0,
        flowingTime: 0,
        totalFlow: 0,
      },
      limitSwitchSummary: {
        totalDuration: 0,
        selectionDuration: 0,
      },
      aesTotal: [],
      dateParam: undefined,
      deviceData: undefined,
      assetObject: {},
      series: undefined,
      filter: {
        devcId: this.$route.params.id,
      },
      id: this.$route.params.id,
      isLoading: false,
      isRefreshed: false,
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 0,
      },
      related: {
        devcType: undefined,
        devcTypes: [
          { name: 'Memory', value: 'memory' },
          { name: 'Battery', value: 'battery' },
          { name: 'Flow Meter', value: 'flowMeter' },
          { name: 'GPS', value: 'gps' },
          { name: 'Engines', value: 'engines' },
          { name: 'CPU Usage', value: 'cpuUsage' },
          { name: 'Disk Space', value: 'diskspace' },
        ],
        fields: [],
        logs: [],
      },
    };
  },
  computed: {
    assetName() {
      const asset = this.deviceData && this.assetObject[this.deviceData.devcMassId];
      return asset ? asset.massName : '';
    },
  },
  watch: {
    '$route.params.id': {
      async handler(newId) {
        if (!newId || newId === this.id) return;
        this.id = newId;
        this.filter.devcId = newId;
        await this.loadDevice();
      },
    },
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        await this.loadDeviceLog();
      } catch (e) {
        console.error('error when loading device detail : ', e);
        if (e.response && e.response.data) {
          if (e.response.data.status.message === 'Authentication Error') {
            this.doLogOut();
          } else {
            this.$toast.error(e.response.data.status.message);
          }
        } else {
          this.$toast.error('Network error');
        }
      } finally {
        this.isLoading = false;
      }
    },
    async loadDeviceLog() {
      if (this.$route.query.value) {
        this.dateParam = dateUtil.queryToDateParam(this.$route.query);
      } else {
        this.dateParam = dateUtil.byInterval('today');
      }

      if (!this.assetObject[this.deviceData.devcMassId]) {
        this.assetObject[this.deviceData.devcMassId] = {};
      }
      if (!this.assetObject[this.deviceData.devcMassId].devices) {
        this.assetObject[this.deviceData.devcMassId].devices = {};
      }

      this.assetObject[this.deviceData.devcMassId].devices[
        this.deviceData.devcUniqueId
      ] = this.deviceData;

      if (
        this.deviceData.devcType === 'flowmeter'
        && this.dateParam.aggregatedUnit !== 'MINUTE'
      ) {
        this.dateParam.functionNames = ['MIN', 'MAX', 'MIN', 'MAX', 'AVG', 'AVG', 'AVG', 'AVG'];
        this.dateParam.functionParams = [
          '@VolTotal', '@VolTotal', '@MassTotal', '@MassTotal',
          '@MassFlowrate', '@VolFlowrate', '@Density', '@Temp',
        ];
      }

      if (this.deviceData.devcType === 'gps') {
        this.dateParam.functionNames = ['SUM', 'AVG'];
        this.dateParam.functionParams = ['@Distance', '@Speed'];
      }

      // Mendapatkan data yang teragregasi dan mengonversi tanggal ke detik
      this.series = await SeriesSvc.getAggregatedData(this.deviceData, dateUtil.msToS(this.dateParam));

      // Memperbarui data perangkat
      const deviceId = this.deviceData.devcMassId;
      const uniqueId = this.deviceData.devcUniqueId;
      const deviceData = this.assetObject[deviceId].devices[uniqueId];
      deviceData.data = this.series?.data?.data?.series || [];

      if (!this.series?.data?.data?.count) {
        return false;
      }

      const seriesData = deviceData.data;
      const context = { dateParam: this.dateParam };
      const adapter = deviceLogAdapters[this.related.devcType];

      if (!adapter) {
        this.related.fields = [];
        this.related.logs = mapSeriesWithDatetime(seriesData);
        return;
      }

      this.related.fields = adapter.buildFields(seriesData, context);
      this.related.logs = adapter.buildLogs(seriesData, context);
      const summary = adapter.buildSummary(seriesData, context);

      if (this.related.devcType === 'gps') this.gpsSummary = summary;
      if (this.related.devcType === 'flowmeter') this.flowmeterSummary = summary;
      if (this.related.devcType === 'limitswitch') this.limitSwitchSummary = summary;
      if (this.related.devcType === 'ae') this.aesTotal = summary;
    },
    onSubmitRange(date) {
      const nextQuery = {
        ...this.$route.query,
        ...dateUtil.dateParamToQuery(date),
      };
      this.$router
        .replace({
          name: 'DeviceDetail',
          query: nextQuery,
        })
        .catch((err) => {
          console.error('Duplicate Route, Skipping... ', err);
        });
      this.load();
    },
    async getAsset() {
      this.isLoading = true;
      try {
        const assetResponse = await AssetSvc.getAsset();
        assetResponse.data.data.forEach((asset) => {
          this.assetObject[asset.massId] = asset;
        });
      } catch (e) {
        console.error('error when getting asset : ', e);
        if (e.response.data) {
          if (e.response.data.status.message === 'Authentication Error') {
            this.doLogOut();
          } else {
            this.$toast.error(e.response.data.status.message);
          }
        } else {
          this.$toast.error('Network error');
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getDevices(notification) {
      this.isLoading = true;
      this.isRefreshed = true;
      try {
        const resp = await DeviceSvc.getDevices({
          params: {
            ...requestBuilder.buildFilters(this.pagination, this.filter),
          },
        });

        const data = resp.data.data.find((o) => parseInt(o.devcId) === parseInt(this.id));
        if (!data) {
          this.$toast.error('Device not found');
          return;
        }
        this.deviceData = data;
        this.related.devcType = data.devcType;

        if (notification) this.$toast.success(notification);
      } catch (e) {
        console.error('error when getting device : ', e);
        if (e.response.data) {
          if (e.response.data.status.message === 'Authentication Error') {
            this.doLogOut();
          } else {
            this.$toast.error(e.response.data.status.message);
          }
        } else {
          this.$toast.error('Network error');
        }
      } finally {
        this.isLoading = false;
        this.isRefreshed = false;
      }
    },
    async loadDevice() {
      await this.getDevices();
      if (this.deviceData) {
        await this.load();
      }
    },
    doLogOut() {
      this.$toast.error('Please re-login');
      this.$store.dispatch('auth/logout');
      this.$router.replace({ name: 'Login' });
    },
  },
  async mounted() {
    await this.getAsset();
    await this.loadDevice();
  },
};
</script>

<style scoped></style>
